import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import styled from 'styled-components'

import 'react-datepicker/dist/react-datepicker.css'
import 'react-datepicker/dist/react-datepicker-cssmodules.css'

let ErrorMsg = styled.div`
  color: red
`;

class DateSelectField extends Component {
  handleChange = value => {
    const { onChange, name } = this.props

    console.log(name);
    console.log(value);
    onChange(name, value)
  }

  render() {
    const {
      name,
      label,
      value,
      touched,
      error,
    } = this.props

    return (
      <div className="input-field-wrapper">
        {label && (
          <h6 className="input-label" htmlFor={name} error={error}>
            {label}
          </h6>
        )}

        <DatePicker
            style={{ paddingTop: '5px' }}
            className="form-control"
            dateFormat="dd/MM/yyyy"
            selected={(value && new Date(value)) || null}
            onChange={this.handleChange}
        />

        {touched && error ? <ErrorMsg>{error}</ErrorMsg> : null}
      </div>
    )
  }
}

export default DateSelectField
